// extracted by mini-css-extract-plugin
module.exports = {"button":"_2ICYR","wrapper":"_3Ruoi","label":"l0Ffw"};